// extracted by mini-css-extract-plugin
export var chevron = "_it-3";
export var chevronRotated = "_it-4";
export var image = "_it-1";
export var imageContainer = "_it-0";
export var shippingAddress = "_it-2";